import { render, staticRenderFns } from "./ApartmentListItem.vue?vue&type=template&id=6dffc35d&scoped=true&lang=pug&"
import script from "./ApartmentListItem.vue?vue&type=script&lang=ts&"
export * from "./ApartmentListItem.vue?vue&type=script&lang=ts&"
import style0 from "./ApartmentListItem.vue?vue&type=style&index=0&id=6dffc35d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dffc35d",
  null
  
)

export default component.exports